/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { DividerSectionFragment } from "@cosmos/hygraph-schema";

import { ArticleChildrenWrap, ResponsiveContainer, SectionContainer, BackgroundContainer } from "@components/elements";
import { css } from "@panda/css";

type DividerSectionProps = Omit<DividerSectionFragment, "__typename" | "id">;

export const DividerSection = ({ edsBackgroundColor, size }: DividerSectionProps): React.JSX.Element => {
	return (
		<BackgroundContainer edsBackgroundColor={edsBackgroundColor}>
			<ResponsiveContainer>
				<SectionContainer disablePaddingBlock>
					<ArticleChildrenWrap size={size || "unbound"}>
						<hr
							className={css({
								width: "100%",
								borderTopWidth: "1px",
								borderTopStyle: "solid",
								borderTopColor: "eds.border.subtle",
							})}
						/>
					</ArticleChildrenWrap>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
